


































import { Component, Vue } from 'vue-property-decorator';
import {NewGameRequest} from '@/proto/banana_pb';

@Component
export default class NewGameForm extends Vue {
  private gameName: string = '';
  private minLetters: string = '2';
  private advancedOpen = false;

  private createGame() {
    const req = new NewGameRequest();
    req.setName(this.gameName);
    req.setMinLettersInWord(parseInt(this.minLetters, 10));
    this.$client.newGame(req, {}, (err, resp) => {
      if (err) {
        console.log(err);
      }
    });
  }
}
